import React, { useCallback } from "react";
import Checkbox from "@ui-kit/form/checkbox";
import Line from "@radarly/components/panels/card-edition/sidebar/line";
import { useCurrentUserLocale } from "@radarly/core/user/use-cases";
import { tr } from "@radarly/i18n";
import {
  DatavizStreamChart,
  updateDatavizOptions,
} from "@radarly/models/dataviz";

export interface SharedPanelsCardEditionSidebarOptionsStreamChartProps {
  dataviz: DatavizStreamChart;
  setDataviz: (dataviz: DatavizStreamChart) => void;
}

export default function SharedPanelsCardEditionSidebarOptionsStreamChart({
  dataviz,
  setDataviz,
}: SharedPanelsCardEditionSidebarOptionsStreamChartProps) {
  const locale = useCurrentUserLocale();

  const updateDisplayVolumes = useCallback(() => {
    const value = dataviz.displayVolumes ? false : true;
    setDataviz(
      updateDatavizOptions(
        dataviz,
        "displayVolumes",
        value as DatavizStreamChart["displayVolumes"]
      )
    );
  }, [dataviz, setDataviz]);

  return (
    <>
      <Line title={tr(locale, "CUSTOM_PAGES::EDITOR::CARD_LEGEND")}>
        <Checkbox
          label={tr(locale, "CUSTOM_PAGES::EDITOR::DATAVIZ::DISPLAY_VOLUMES")}
          checked={dataviz.displayVolumes || undefined}
          onClick={updateDisplayVolumes}
        />
      </Line>
    </>
  );
}
